import { BannerComponent, BookingComponent } from "../../components";
import Breadcrumb from "./components/Breadcrumb";
import React, { useState } from "react";
import Filter from "./components/Filter";
import EndowList from "./components/EndowList";
import useFetch from "../../commons/useFetch";
function Endow() {
  const {data : endows}=useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/endows')
  const [hotels, setHotels] = useState();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [check, setCheck] = useState([]);

  function Hotels(value) {
    setHotels(value);
  }

  function FromDate(dateString) {
    setFromDate(dateString);
  }

  function ToDate(dateString) {
    setToDate(dateString);
  }

  function CheckBox(value) {
    setCheck(value);
  }

  return (
    <div className="endow">
      <BannerComponent />
      <BookingComponent />
      <div className="endowContent">
        <Breadcrumb />
        <div className="container">
          <div className="titlepage">
            <h5>
              Khám phá <span>ưu đãi</span> dành riêng cho bạn ngay hôm nay!
            </h5>
          </div>
          <Filter
            onChangeHotels={Hotels}
            onchangeFromDate={FromDate}
            onchangeToDate={ToDate}
            filterCheck={CheckBox}
          />
          {endows && (
            <EndowList
              endows={endows}
              hotels={hotels}
              fromDate={fromDate}
              toDate={toDate}
              check={check}
            />
          )}
        </div>
      </div>
    </div>
  );
}
export default Endow;
